const routes = {
  '/app/zap': {
    fetch: () =>
      import(
        /* webpackChunkName: 'zap-details-route' */ 'app/zap-details/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
